export default function canadianSyllabicsLargeTransform(input) {
  return input
    .replace(/A/gi, "ᗩ")
    .replace(/B/gi, "ᙖ")
    .replace(/C/gi, "ᑕ")
    .replace(/D/gi, "Ð")
    .replace(/E/gi, "ᕮ")
    .replace(/F/gi, "₣")
    .replace(/G/gi, "Ǥ")
    .replace(/H/gi, "ᕼ")
    .replace(/I/gi, "Ɨ")
    .replace(/J/gi, "ᒎ")
    .replace(/K/gi, "Ḱ")
    .replace(/L/gi, "ᒪ")
    .replace(/M/gi, "ᗰ")
    .replace(/N/gi, "ᘉ")
    .replace(/O/gi, "〇")
    .replace(/P/gi, "ᑭ")
    .replace(/Q/gi, "Ⴓ")
    .replace(/R/gi, "ᖇ")
    .replace(/S/gi, "ᔕ")
    .replace(/T/gi, "Ƭ")
    .replace(/U/gi, "ᑌ")
    .replace(/V/gi, "Ⅴ")
    .replace(/W/gi, "ᗯ")
    .replace(/X/gi, "᙭")
    .replace(/Y/gi, "ϒ")
    .replace(/Z/gi, "乙")
    .replace(/ /gi, "ㅤ");
}
